import React, { useEffect, useRef } from "react";
import { GeocodingSuggestion } from "../utils/geocoding";

interface LocationInputProps {
  location: string;
  loading: boolean;
  suggestionLoading: boolean;
  suggestions: GeocodingSuggestion[];
  onLocationChange: (location: string) => void;
  onFetchData: () => void;
  onSuggestionSelect: (suggestion: GeocodingSuggestion) => void;
  onClearSuggestions: () => void;
}

const LocationInput: React.FC<LocationInputProps> = ({
  location,
  loading,
  suggestionLoading,
  onLocationChange,
  onFetchData,
  suggestions,
  onSuggestionSelect,
  onClearSuggestions,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !loading) {
      onFetchData();
    }
  };

  // Click outside to dismiss suggestions
  useEffect(() => {
    if (suggestions.length === 0) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        onClearSuggestions();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [suggestions, onClearSuggestions]);

  return (
    <div className="location-container">
      <label htmlFor="location-input">Oraș: </label>
      <div className="input-container" ref={wrapperRef}>
        <input
          id="location-input"
          type="text"
          value={location}
          onChange={(e) => onLocationChange(e.target.value)}
          onKeyDown={handleKeyDown}
          onClick={(e) => e.currentTarget.select()}
          placeholder="Introduceți orașul (ex: Iași)"
          autoComplete="off"
        />
        {suggestions.length > 0 && (
          <ul className="suggestions-dropdown">
            {suggestions.map((s, i) => (
              <li
                key={i}
                className="suggestion-item"
                onClick={() => onSuggestionSelect(s)}
              >
                {s.display_name}
              </li>
            ))}
          </ul>
        )}
        <button onClick={onFetchData} disabled={loading || suggestionLoading}>
          {loading
            ? "Încărcare..."
            : suggestionLoading
              ? "Căutare..."
              : "Calculează"}
        </button>
      </div>
    </div>
  );
};

export default LocationInput;
